type KeyOrValue = string | number | symbol;

export const swapKeyWithValue = <T extends Record<KeyOrValue, KeyOrValue>>(
    obj: T
): { [K in keyof T as T[K]]: K } =>
    Object.fromEntries(Object.entries(obj).map((a) => a.reverse()));

export const getTypedKeys = <T extends Record<string, unknown>>(obj: T) => {
    return Object.keys(obj) as Array<keyof T>;
};

export const isObjectEmpty = <T extends Record<string, unknown>>(object: T) => {
    return Object.keys(object).length === 0;
};
